module.exports = __webpack_public_path__ + "static/media/tc.c3867f8d.svg";